import { LegalClientSaveKnowledgeAndExperienceParam } from 'api/types/params';
import { isYes } from 'helpers';

import { KnowledgeAndExperienceFormType } from '../../forms/knowledgeAndExperienceForm';

export const getSubmitData = (
  values: KnowledgeAndExperienceFormType
): LegalClientSaveKnowledgeAndExperienceParam => ({
  financialInstruments: values.financialInstruments?.map((v) => v.value),
  otherFinancialInstrument: values.otherFinancialInstrument,
  hasQualifiedOfficersForInvestmentDecisions: isYes(
    values.hasQualifiedOfficersForInvestmentDecisions
  ),
  educationLevel: values.educationLevel?.value,
  heldFinancialPositionInLast5Years:
    values.hasQualifiedOfficersForInvestmentDecisions !== undefined
      ? isYes(values.hasQualifiedOfficersForInvestmentDecisions)
      : undefined,
});
